import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "../ArrayPool.js";
import { equals as t } from "../lang.js";
import { ReentrantObjectPool as r } from "../ReentrantObjectPool.js";
import { schedule as o } from "../scheduling.js";
import { someSet as l } from "../SetUtils.js";
import { generateUID as i } from "../uid.js";
import { valueOf as n } from "./get.js";
import { reaction as s, reactionDeferred as u } from "./trackingUtils.js";
import { once as a, parse as c } from "./utils.js";

var d = /*#__PURE__*/function () {
  function d() {
    _classCallCheck(this, d);

    this.uid = i(), this.removed = !1, this.type = null, this.oldValue = null, this.callback = null, this.getValue = null, this.target = null, this.path = null, this.equals = null;
  }

  _createClass(d, [{
    key: "notify",
    value: function notify(e, t) {
      0 === this.type ? this.callback.call(this.target, e, t, this.path, this.target) : this.callback.call(null, e, t);
    }
  }, {
    key: "acquire",
    value: function acquire(e, t, r, o, l, n, s) {
      this.uid = i(), this.removed = !1, this.type = e, this.oldValue = t, this.callback = r, this.getValue = o, this.target = l, this.path = n, this.equals = s;
    }
  }, {
    key: "release",
    value: function release() {
      this.target = this.path = this.oldValue = this.callback = this.getValue = null, this.uid = i(), this.removed = !0;
    }
  }], [{
    key: "acquireUntracked",
    value: function acquireUntracked(e, r, o, l, i) {
      return this.pool.acquire(0, e, r, o, l, i, t);
    }
  }, {
    key: "acquireTracked",
    value: function acquireTracked(e, t, r, o) {
      return this.pool.acquire(1, e, t, r, null, null, o);
    }
  }]);

  return d;
}();

d.pool = new r(d);
var h = new e(),
    f = new Set();
var m;

function p(e) {
  f.delete(e), f.add(e), m || (m = o(q));
}

function v(e) {
  if (e.removed) return;
  var t = e.oldValue,
      r = e.getValue();
  e.equals(t, r) || (e.oldValue = r, e.notify(r, t));
}

function g(e) {
  var t = Array.from(f);

  for (var _r = 0; _r < t.length; _r++) {
    var _o = t[_r];
    _o.target === e && (v(_o), f.delete(_o));
  }
}

function _(e) {
  var _iterator = _createForOfIteratorHelper(f.values()),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _t = _step.value;
      _t.target === e && (_t.removed = !0);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

function q() {
  var e = 10;

  for (; m && e--;) {
    m = null;

    var _e = j(),
        _t2 = h.acquire();

    var _iterator2 = _createForOfIteratorHelper(_e),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _r2 = _step2.value;
        var _e2 = _r2.uid;
        v(_r2), _e2 === _r2.uid && _r2.removed && _t2.push(_r2);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    var _iterator3 = _createForOfIteratorHelper(f),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _r3 = _step3.value;
        _r3.removed && (_t2.push(_r3), f.delete(_r3));
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }

    var _iterator4 = _createForOfIteratorHelper(_t2),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var _r4 = _step4.value;
        d.pool.release(_r4);
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }

    h.release(_t2), h.release(_e), k.forEach(function (e) {
      return e();
    });
  }
}

function j() {
  var e = h.acquire();
  e.length = f.size;
  var t = 0;

  var _iterator5 = _createForOfIteratorHelper(f),
      _step5;

  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var _r5 = _step5.value;
      e[t] = _r5, ++t;
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }

  return f.clear(), e;
}

var k = new Set();

function y(e) {
  return k.add(e), {
    remove: function remove() {
      k.delete(e);
    }
  };
}

function V(e, t, r) {
  var o = c(e, t, r, function (e, t, r) {
    var l,
        i,
        s = u(function () {
      return n(e, t);
    }, function (n, s) {
      e.__accessor__.destroyed || l && l.uid !== i ? o.remove() : (l || (l = d.acquireUntracked(n, r, s, e, t), i = l.uid), p(l));
    });
    return {
      remove: a(function () {
        s.remove(), l && (l.uid !== i || l.removed || (l.removed = !0, p(l)), l = null), o = s = null;
      })
    };
  });
  return o;
}

function b(e, r, o) {
  var l = c(e, r, o, function (e, r, o) {
    var i = !1;
    return s(function () {
      return n(e, r);
    }, function (n, s) {
      e.__accessor__.destroyed ? l.remove() : i || (i = !0, t(s, n) || o.call(e, n, s, r, e), i = !1);
    });
  });
  return l;
}

function w(e, t, r) {
  var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
  return !e.__accessor__ || e.__accessor__.destroyed ? {
    remove: function remove() {}
  } : o ? b(e, t, r) : V(e, t, r);
}

function U(e, t, r) {
  var o,
      l,
      i = u(e, function (e, n) {
    o && o.uid !== l ? i.remove() : (o || (o = d.acquireTracked(e, t, n, r), l = o.uid), p(o));
  });
  return {
    remove: a(function () {
      i.remove(), o && (o.uid !== l || o.removed || (o.removed = !0, p(o)), o = null), i = null;
    })
  };
}

function S(e, t, r) {
  var o = !1;
  return s(e, function (e, l) {
    o || (o = !0, r(l, e) || t(e, l), o = !1);
  });
}

function A(e, r) {
  var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
  var l = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : t;
  return o ? S(e, r, l) : U(e, r, l);
}

function P(e) {
  return l(f, function (t) {
    return t.oldValue === e;
  });
}

export { y as afterDispatch, w as default, q as dispatch, g as dispatchTarget, P as isValueInUse, _ as removeTarget, S as syncWatchTracked, w as watch, A as watchTracked };